import TableHeader from 'features/beersManager/shared/TableHeader/TableHeader';
import {beerManagerModes} from 'features/beersManager/typescript';
import {PubBeer} from 'typescript/models/PubBeer';

import ListBeersBody from './ListBeersBody/ListBeersBody';
import './ListBeersTable.scss';

interface IProps {
  beersList: PubBeer[];
}

const ListBeersTable = ({beersList}: IProps) => {
  return (
    <table data-testid={`beers-table-${beerManagerModes.listBeers}`} className="list-beers-table">
      <TableHeader />
      <ListBeersBody beersList={beersList} />
    </table>
  );
};

export default ListBeersTable;
